import styled from 'styled-components'

export const Item = styled.div`
  display: flex;
  align-items: center;
  border-radius: 8px;
  padding: 8px 16px;
  padding-left: 12px;
  background-color: ${({ theme }) => theme.cor64}!important;
  margin-bottom: 8px;
  box-shadow: ${({ $isDragging }) =>
    $isDragging ? '0 4px 12px rgba(0, 0, 0, 0.15)' : '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)'};
  position: relative;
  color: ${({ theme }) => theme.cor9}!important;
  cursor: ${({ $isDragging, $draggable }) => ($isDragging ? 'grabbing' : $draggable ? 'pointer' : 'default')};
  opacity: ${({ $isDragging }) => ($isDragging ? 0.5 : 1)};
  transition: box-shadow 0.15s ease, opacity 0.15s ease;
`

export const Symbol = styled.div`
  font-size: 24px;
  font-weight: 700;
  min-width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.cor54};
`

export const DragHandle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: ${({ theme }) => theme.cor54};
  margin-right: 16px;
  cursor: grab;
  touch-action: none;
  &:active {
    cursor: grabbing;
  }
`

export const ItemContent = styled.div`
  flex: 1;
  min-width: 0;
`

export const IconButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`
